import angularModule from 'FrontRoyalTimer/angularModule/scripts/front_royal_timer_module';
import TimerSingleton from '../../TimerSingleton';

angularModule.factory('timerSingleton', ['$injector', $injector => new TimerSingleton($injector)]);
